/* eslint-disable array-element-newline */
import ENTITY_INFO from '../data/entity_info.json';
import ar from '../languages/ar';

// Launched on Nov (11 => index in the array is 10) 20, 1998
const time = (Date.now() - new Date(1998, 10, 20)) / (1000 * 60 * 60 * 24);
const timeSentinel6 = (Date.now() - new Date(2020, 10, 10)) / (1000 * 60 * 60 * 24);

const SPACECRAFT_CONSTELLATIONS = {
	Aqua: ['sc_aqua'],
	Aura: ['sc_aura'],
	CALIPSO: ['sc_calipso'],
	CloudSat: ['sc_cloudsat'],
	CYGNSS: ['sc_cygnss_1', 'sc_cygnss_2', 'sc_cygnss_3', 'sc_cygnss_4', 'sc_cygnss_5', 'sc_cygnss_7', 'sc_cygnss_8'],
	GPM: ['sc_gpm'],
	GRACE: ['sc_grace_fo1', 'sc_grace_fo2'],
	GRIFEX: ['sc_grifex'],
	HyspIRI: ['sc_hyspiri'],
	ICESat: ['sc_icesat_2'],
  ISS: ['sc_iss', 'sc_iss_oco_3', 'sc_iss_ecostress', 'sc_iss_emit', 'sc_iss_cowvr_tempest'],
	Jason: ['sc_jason_3'],
	Landsat7: ['sc_landsat_7'],
	Landsat8: ['sc_landsat_8'],
	Landsat9: ['sc_landsat_9'],
  'M-Cubed2': ["sc_mcubed_2"],
	NISAR: ['sc_nisar'],
  "NOAA-20": ['sc_noaa_20'],
  "NOAA-21": ['sc_noaa_21'],
	'OCO-2': ['sc_oco_2'],
  'OCO-3': ['sc_iss_oco_3', 'sc_iss', 'sc_iss_ecostress', 'sc_iss_emit', 'sc_iss_cowvr_tempest'],
  ECOSTRESS: ['sc_iss_ecostress', 'sc_iss', 'sc_iss_oco_3', 'sc_iss_emit', 'sc_iss_cowvr_tempest'],
  EMIT: ['sc_iss_emit', 'sc_iss', 'sc_iss_oco_3', 'sc_iss_ecostress', 'sc_iss_cowvr_tempest'],
  'COWVR/TEMPEST': ['sc_iss_cowvr_tempest', 'sc_iss', 'sc_iss_oco_3', 'sc_iss_ecostress', 'sc_iss_emit'],
	PACE: ['sc_pace'],
	'PREFIRE-1': ['sc_prefire_1', 'sc_prefire_2'],
	'PREFIRE-2': ['sc_prefire_2', 'sc_prefire_1'],
  RainCube: ['sc_raincube'],
	'Sentinel-6B': ['sc_sentinel_6b'],
	'Sentinel6': ['sc_sentinel_6'],
	SMAP: ['sc_smap'],
  SORCE: ['sc_sorce'],
	Suomi_NPP: ['sc_suomi_npp'],
	SWOT: ['sc_swot'],
	TEMPO: ['sc_tempo'],
	Terra: ['sc_terra'],
	'TROPICS-01': ['sc_tropics_01', 'sc_tropics_03', 'sc_tropics_05', 'sc_tropics_06', 'sc_tropics_07'],
	'TROPICS-03': ['sc_tropics_03', 'sc_tropics_01', 'sc_tropics_05', 'sc_tropics_06', 'sc_tropics_07'],
	'TROPICS-05': ['sc_tropics_05', 'sc_tropics_01', 'sc_tropics_03', 'sc_tropics_06', 'sc_tropics_07'],
	'TROPICS-06': ['sc_tropics_06', 'sc_tropics_01', 'sc_tropics_03', 'sc_tropics_05', 'sc_tropics_07'],
	'TROPICS-07': ['sc_tropics_07', 'sc_tropics_01', 'sc_tropics_03', 'sc_tropics_05', 'sc_tropics_06'],
	'sc_saudisat_4': ['sc_saudisat_4']
};

// Create SPACECRAFT_WITH_INSTRUMENTS from entity info.
const SPACECRAFT_WITH_INSTRUMENTS = Object.keys(ENTITY_INFO).reduce((acc, spacecraftId) => {

	const { instrumentParent, stylizedName } = ENTITY_INFO[spacecraftId];

	if (instrumentParent && stylizedName) {
		acc[instrumentParent] = [
			...(acc[instrumentParent] || []),
			{ instrumentId: spacecraftId, stylizedName }
		];
	}
	return acc;
}, {});

const SPACECRAFT_GEOSTATIONARY = ['sc_tempo'];

const SPACECRAFT_LAND = [
	'sc_grace_fo1',
	'sc_grace_fo2',
	'sc_icesat_2',
	'sc_landsat_7',
	'sc_landsat_8',
	'sc_landsat_9',
	'sc_smap',
	'sc_terra'
];
const SPACECRAFT_SEA = ['sc_jason_3', 'sc_pace', 'sc_sentinel_6', 'sc_swot'];

const SPACECRAFT_ATMOSPHERE = [
	'sc_aqua',
	'sc_aura',
	'sc_calipso',
	'sc_cloudsat',
	'sc_cygnss_1',
	'sc_cygnss_2',
	'sc_cygnss_3',
	'sc_cygnss_4',
	'sc_cygnss_5',
	'sc_cygnss_6',
	'sc_cygnss_7',
	'sc_cygnss_8',
	'sc_gpm',
	'sc_oco_2',
	'sc_prefire_1',
	'sc_prefire_2',
	'sc_suomi_npp',
	'sc_tempo',
	'sc_tropics_01',
	'sc_tropics_03',
	'sc_tropics_05',
	'sc_tropics_06',
	'sc_tropics_07'
];

const TRAIL_COLORS = {
	ATMOSPHERE: [0.76, 0.44, 0.18, 0.5],
	LAND: [0.22, 0.64, 0.22, 0.5],
	SEA: [0.3, 0.53, 0.84, 0.5]
};

const SPACECRAFT_DATA = {
	sc_saudisat_4: {
		absolutePath: true,
		clickable: true,
		thumb: 'assets/images/iss_320x240.jpg',
		url: 'https://www.nasa.gov/mission_pages/station/main/index.html',
		id: 1,
		target: '_blank',
		categories: ['operating', 'land', 'earth_now'],
		time_in_orbit: '900 days',
		description: '',
		title: 'SAUDISAT 4',
		external_id: 'sc_saudisat_4',
		target_entity: 'sc_saudisat_4',
		date: 'May 3, 2019',
		launch_date: 'May 3, 2019',
    end_date: '',
		launch_location: '',
		launch_vehicle: ''
	}
	
};

const SATELLITES_NOW_DATA = {
	value: 'satellites',
	title: 'الأقمار الصناعية الآن',
	description: 'وكالة ناسا لديها أكثر من أربع وعشرين قمراً صناعياً لدراسة الأرض. ومشروع الأرض الآن ”Earth Now“ يقدم العديد من الأقمار الصناعية التي تركز على العلامات الحيوية لكوكبنا. انقر على أي قمر صناعي لعرض نموذج ثلاثي الأبعاد له، أو شاهد أحدث البيانات في قائمة العلامات الحيوية.\n',
	sphereMapThumbSrc: 'sat_now.webp',
	datasetGroups: []
};

export {
	SPACECRAFT_CONSTELLATIONS,
	SPACECRAFT_WITH_INSTRUMENTS,
	SATELLITES_NOW_DATA,
	SPACECRAFT_DATA,
	SPACECRAFT_LAND,
	SPACECRAFT_SEA,
	SPACECRAFT_ATMOSPHERE,
	SPACECRAFT_GEOSTATIONARY,
	TRAIL_COLORS
};
